const LAST_SHOW_RESULT_KEY = "concent_result"

// {"google": ["ad_storage"],"adobe": ["aa","target"],"other":["web","rule"]}
const DAYS = 1000 * 60 * 60 * 24;
const ONEMONTH = 30 * DAYS;
const ONEYEAR = 365 * DAYS;
const getCookie = (key) => {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1"));
}

export const isNeedShowModal = () => {
    return !getCookie(LAST_SHOW_RESULT_KEY);
}


export const setResultCookie = (data, isAll) => {
    const expiresTime = isAll ? ONEYEAR : ONEMONTH;
    document.cookie = `${LAST_SHOW_RESULT_KEY}=${JSON.stringify(data)}; expires=${new Date(+new Date() + expiresTime).toUTCString()}; domain=.shangri-la.com; path=/`;
};

export const getResult = () => {
    try{
       return JSON.parse(getCookie(LAST_SHOW_RESULT_KEY));
    } catch (e) {
        return {};
    }
}